import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import './SalesItemTable.css';

export default class SalesItemTable extends React.Component {
  
  static propTypes = {
    className: PropTypes.string,
    title: PropTypes.node,
    data: PropTypes.array,
    columnHeaders: PropTypes.array,
  };

  state = {
    selectedIdx: -1
  };

  render() {
    return (
      <div className={classnames('SalesItemTable', this.props.className)}>
        <div className="SalesItemTable__content">
          <h2 className="SalesItemTable__title">
            {this.props.title}
          </h2>
          <div className="SalesItemTable__items">
            {
              this.props.data.map(({ title, items }, idx) => (
                <div
                  key={idx}
                  className={classnames('SalesItemTable__item', {
                    'SalesItemTable__item--selected': this.state.selectedIdx === idx
                  })}
                  onClick={this._onClickBtn.bind(this, idx)}>
                  <div className="SalesItemTable__itemContent">
                    <div className="SalesItemTable__itemTitleContainer">
                      <div className="SalesItemTable__mobileDownArrow">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                          <polygon fillRule="evenodd" points="8 9 12 16 16 9"/>
                        </svg>
                      </div>
                      <div className="SalesItemTable__itemTitle">
                        {title}
                      </div>
                      <div className="SalesItemTable__downArrow">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                          <polygon fillRule="evenodd" points="8 9 12 16 16 9"/>
                        </svg>
                      </div>
                    </div>
                    <ReactCSSTransitionGroup
                      transitionName="transition"
                      transitionEnterTimeout={400}
                      transitionLeaveTimeout={1}>
                      {
                        this.state.selectedIdx === idx &&
                        <table className="SalesItemTable__detailTable">
                          <thead>
                            <tr className="SalesItemTable__detailRow">
                              <th className="SalesItemTable__detailHead SalesItemTable__detailHead--1">{this.props.columnHeaders[0]}</th>
                              <th className="SalesItemTable__detailHead SalesItemTable__detailHead--2">{this.props.columnHeaders[1]}</th>
                              <th className="SalesItemTable__detailHead SalesItemTable__detailHead--3">{this.props.columnHeaders[2]}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              items.map((details, idx) => (
                                <tr
                                  key={idx}
                                  className="SalesItemTable__detailRow">
                                  {
                                    details.map((detail, idx) => (
                                      <td
                                        key={idx}
                                        className="SalesItemTable__detailData">
                                        {detail}
                                      </td>
                                    ))
                                  }
                                </tr>
                              ))
                            }
                          </tbody>
                        </table>
                      }
                    </ReactCSSTransitionGroup>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    );
  }

  _onClickBtn = selectedIdx => {
    if (this.state.selectedIdx === selectedIdx) {
      this.setState({
        selectedIdx: -1
      });
    } else {
      this.setState({
        selectedIdx
      });
    }
  };

}


// WEBPACK FOOTER //
// ./src/components/SalesItemTable.js